module.exports = __webpack_public_path__ + "img/Icons-08.46d6149f.png";